/**
 *  @deprecated Superceeded by IDB_units from dexie.
 *
 * You probably don't want to use this, it should be removed in the future. #4948
 */

import { IDB_rowsDelete, IDB_rowsReadAll, IDB_rowsWrite, IDB_rowWrite } from './IDB.queries'
import { IDB_globalDb } from './IDB'
import type { Type_IUnit } from '../Type/Type.hive'

export function IDB_unitsDelete(ids: number[]) {
    return IDB_rowsDelete(IDB_globalDb, 'units', ids)
}

export function IDB_unitsReadAll() {
    return IDB_rowsReadAll<Type_IUnit>(IDB_globalDb, 'units')
}

export function IDB_unitsWrite(units: Type_IUnit[]) {
    return IDB_rowsWrite(IDB_globalDb, 'units', units)
}

export function IDB_unitWrite(unit: Type_IUnit) {
    return IDB_rowWrite(IDB_globalDb, 'units', unit)
}
